export default "__VITE_ASSET__BlP9RF8l__"